import React, { Component } from 'react';
import { DESC } from '../../../BaseDataTable';
import { Tooltip } from '@material-ui/core';
import { ArrowUpward, ArrowDownward} from '@material-ui/icons';
import { arrayOf, shape, string, any, func} from 'prop-types';
import { newAdUsersPerAdsKey } from '../../../../helpers/constant';

import classNames from 'classnames';
import styles from './styles.scss';

export default class CreativeTableHead extends Component {
  static propTypes = {
    headers: arrayOf(shape({
      title: string,
      key: string
    })).isRequired,
    tooltipText: string,
    sortKey: string,
    sortStatus: shape({any}),
    onCellClick: func
  }

  static defaultProps = {
    tooltipText: 'Sort'
  }

  drawArrowIcon() {
    const { sortKey, sortStatus } = this.props;
    const arrowIcon = sortStatus[sortKey] === '' || 
                      sortStatus[sortKey] === DESC? 
                      <ArrowDownward className={styles.arrowIcon}/> :
                      <ArrowUpward className={styles.arrowIcon}/>;
    return <span>{arrowIcon}</span>
  }

  drawTableHead() {
    const { headers, sortKey, onCellClick, tooltipText } = this.props;
    return headers && headers.map( header => {
      const { title, key, icon } = header;
      const arrowIcon = sortKey === key && this.drawArrowIcon();
      if (title && key) {
        return (
          <div
            className={classNames(
              styles.tableCell,
              styles.tableHeadCell,
              {
                [styles.metricPerAdCell]: key === 'newAdUsersPerAds' || key === 'visitOfAds'
              }
            )}
            onClick={onCellClick(key)} key={key}
          >
              <Tooltip className={styles.tooltip} title={tooltipText} placement="top-start">
                <div>
                  {arrowIcon}
                  <span>{title}</span>
                </div>
              </Tooltip>
              {icon}
          </div>
        )
      }
    })
  }
  render() {
    const tableCell = this.drawTableHead();
    return(
      <div className={styles.tableRow}>
        {tableCell}
      </div>
    )
  }
}
